import animation from '@cannect/constants/animation'
import { cn } from '@cannect/lib/utils'
import { Typography } from '@cannect/new-components/atoms'
import { AnimatePresence, motion } from 'framer-motion'
import { useEffect, useRef } from 'react'

type TCounterBadgeProps = {
  quantity: number
  className?: string
  isLoading?: boolean
}
export const CounterBadge = ({ quantity, className, isLoading = false }: TCounterBadgeProps) => {
  const prevQuantityRef = useRef(quantity || 0)
  const animationDirection = quantity > prevQuantityRef.current ? 'increment' : 'decrement'

  useEffect(() => {
    prevQuantityRef.current = quantity
  }, [quantity])

  if (quantity === 0) return null

  if (isLoading)
    return (
      <div
        className={cn('absolute -right-1 -top-1 h-[15px] w-[15px] animate-pulse rounded-full bg-gray-200', className)}
      />
    )
  return (
    <div
      className={cn(
        'absolute -right-1 -top-1 flex h-[15px] min-w-[15px] items-center justify-center rounded-full bg-error-700 px-[3px] outline outline-2 outline-white',
        className
      )}>
      <AnimatePresence mode="popLayout">
        <div className="flex flex-col items-center">
          <motion.div
            key={quantity}
            initial={animationDirection === 'increment' ? animation.counter.slideUp : animation.counter.slideDown}
            animate={{ y: '0', opacity: 1, scale: 1, filter: 'blur(0px)' }}
            exit={animationDirection === 'increment' ? animation.counter.slideDown : animation.counter.slideUp}
            transition={animation.counter.spring}>
            <Typography.Text
              weight="medium"
              type="paragraphTwo"
              className="text-center leading-none text-white [&&]:text-[10px]">
              {quantity}
            </Typography.Text>
          </motion.div>
        </div>
      </AnimatePresence>
    </div>
  )
}
